import { render } from "./GrapesSavePage.vue?vue&type=template&id=43658b37"
import script from "./GrapesSavePage.vue?vue&type=script&lang=js"
export * from "./GrapesSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script